import { Button, Dialog, TextField } from "@mui/material";
import { useEffect, useState } from "react";
import { useSnackbar } from "notistack";
import { ApiRequest } from "GlobalFunctions";
import AutocompleteField from "elements/AutocompleteField";

export default function AssetsEditor(props: any) {
  const { setLoading, openEditor, setOpenEditor, asset_id, loadList } = props;
  const { enqueueSnackbar } = useSnackbar();

  const defaultValues = {
    asset_id: asset_id || "",
    client_id: "",
    serial: "",
    description: "",
    contract: "",
    size: "",
    comments: "",
  } as any;

  const [formValues, setFormValues] = useState<any>(defaultValues);

  useEffect(() => {
    if (openEditor) {
      if (asset_id) {
        loadDetails();
      } else {
        setFormValues({ ...defaultValues, asset_id: "" });
      }
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [openEditor, asset_id]);

  const loadDetails = async () => {
    await ApiRequest({
      url: "/purchases/assets/details",
      method: "get",
      headers: {
        ltkn: localStorage.getItem("ltkn"),
      },
      query: { asset_id },
      setResponse: (response: any) => {
        const data = response?.data || response;
        setFormValues({
          asset_id: data.asset_id ?? asset_id,
          client_id: data.client_id ?? "",
          serial: data.serial ?? "",
          description: data.description ?? "",
          return_date: data.return_date ?? "",
          contract: data.contract ?? "",
          size: data.size ?? "",
          comments: data.comments ?? "",
        });
      },
    });
  };

  const handleInputChange = (e: { target: { name: string; value: any } }) => {
    const { name, value } = e.target;
    setFormValues({ ...formValues, [name]: value });
  };

  const handleSubmit = async () => {
    // Basic validation similar to mobile
    if (!formValues.client_id) return enqueueSnackbar("Debe seleccionar un cliente", { variant: "error" });
    if (!formValues.description) return enqueueSnackbar("Debe ingresar la descripción", { variant: "error" });
    if (!formValues.serial) return enqueueSnackbar("Debe ingresar el serial", { variant: "error" });

    setLoading(true);
    const body = new FormData();
    body.append("formValues", JSON.stringify(formValues));

    await ApiRequest({
      url: "/purchases/assets/addedit",
      method: "post",
      headers: {
        ltkn: localStorage.getItem("ltkn"),
      },
      body,
      formData: true,
      setResponse: (response: any) => {
        if (response.status === "success") {
          enqueueSnackbar("Activo guardado con éxito", { variant: "success" });
          setOpenEditor(false);
          loadList && loadList();
        } else {
          enqueueSnackbar(response.message || "Error al guardar el activo", { variant: "error" });
        }
        setLoading(false);
      },
    });
  };

  return (
    <Dialog open={openEditor} onClose={() => setOpenEditor(false)}>
      <div className="DialogContainer" style={{ maxWidth: 620 }}>
        <div className="ModuleWrapper">
          <div className="boxContainerHeader">
            <div className="boxContainerTitle">
              <h2 className="h2_title">{asset_id ? "Editar activo" : "Nuevo activo"}</h2>
              <span className="h2_subtitle">{asset_id ? "Editar" : "Crear"}</span>
            </div>
          </div>

          <div className="input_group">
            <AutocompleteField
              label="Cliente"
              endpoint="/clients/list"
              fullwidth
              value={formValues.client_id}
              onChange={(data: any) => setFormValues({ ...formValues, client_id: data ? data.value : "" })}
              sx={{ minWidth: "500px" }}
            />

            <div className="input_row">
              <TextField
                id="description"
                name="description"
                label="Descripción"
                type="text"
                required
                fullWidth
                value={formValues.description}
                onChange={handleInputChange}
              />
              <TextField
                id="serial"
                name="serial"
                label="Serial"
                type="text"
                required
                fullWidth
                value={formValues.serial}
                onChange={handleInputChange}
              />
            </div>

            <div className="input_row">
              <TextField
                id="contract"
                name="contract"
                label="Contrato"
                type="text"
                fullWidth
                value={formValues.contract}
                onChange={handleInputChange}
              />
              <TextField
                id="size"
                name="size"
                label="Tamaño"
                type="number"
                fullWidth
                value={formValues.size}
                onChange={handleInputChange}
              />
            </div>

              
              <TextField
                id="comments"
                name="comments"
                label="Comentarios"
                multiline
                rows={4}
                type="text"
                fullWidth
                value={formValues.comments}
                onChange={handleInputChange}
              />
          </div>

          <div className="dialogButtons">
            <Button onClick={() => setOpenEditor(false)} variant="outlined">
              Cancelar
            </Button>
            <Button onClick={handleSubmit} variant="contained">
              Guardar
            </Button>
          </div>
        </div>
      </div>
    </Dialog>
  );
}
